import React from 'react';
import IssueLinkComp from '@atlassian/jira-portfolio-3-common/src/issue-link';
import GroupContainer from '../container';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

function Epic({
	height,
	width,
	position,
	issueId,
	issuesById,
	issueTypesById,
	projectsById,
}: Props) {
	const issue = issuesById[issueId] ?? null;
	if (!issue) {
		return <></>;
	}
	const issueType = issueTypesById[`${issue.type}`];
	const project = projectsById[issue.project];
	return (
		<GroupContainer
			{...{ height, width, position }}
			title={issue.summary}
			tooltipKey={issue.id}
			testId={`portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.epic-group-${issue.id}`}
			iconBefore={
				issueType && (
					<div
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className={styles.icon}
						style={{
							backgroundImage: `url(${issueType.iconUrl})`,
						}}
					/>
				)
			}
		>
			{project && <IssueLinkComp issueKey={issue.issueKey} projectKey={project.key} />}
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<span className={styles.issueSummary}>{issue.summary}</span>
		</GroupContainer>
	);
}

export default Epic;
